export enum LogicalSeparator {
	AND = "and",
	OR = "or",
}
